<a [routerLink]="'/test/PlayList-minCard'">
    <button>PlayList-minCard</button>
</a>

<a [routerLink]="'/test/slide-menu'">
    <button>Slide-menu</button>
</a>

<a [routerLink]="'/Auth'">
  <button>Auth page</button>
</a>

<a [routerLink]="'/test/contextMenu'">
  <button>contextMenu</button>
</a>
